/* (c) Copyright Frontify Ltd., all rights reserved. */

export const OVERLAY_CONTAINER_LIGHT_THEME_STYLING = 'tw-bg-base tw-border tw-border-line';
export const OVERLAY_CONTAINER_DARK_THEME_STYLING =
    'tw-bg-box-neutral-mighty tw-text-box-neutral-mighty-inverse tw-border tw-border-line-mighty';

export const ARROW_DARK_THEME = 'before:tw-border before:tw-border-line-mighty before:tw-bg-box-neutral-mighty';
export const ARROW_LIGHT_THEME = 'before:tw-border before:tw-border-line before:tw-bg-base';
